<!-- Side Structure -->
<template>
  <div class="sidebar app-sidebar" :class="sidebarSelectedFilter.class">
    <v-toolbar flat class="transparent scroll-area navigation">
      <v-list>
        <v-list-tile class="sidebar-logo my-0">
          <bp-switcher />
        </v-list-tile>
        <hr dark class="sidebar-dividers my-0">
        <!-- <v-list-tile class="sidebar-menu my-0">
          <notifications v-if="!isForCreativeBuilder" />
        </v-list-tile> -->
        <!-- <hr class="sidebar-dividers my-0" v-if="!isForCreativeBuilder"> -->
        <vue-perfect-scrollbar :settings="settings">
          <v-list-tile
            v-if="isForRichMediaAdBuilder"
            class="sidebar-menu my-0"
            :to="getRedirectRoute('richMediaAdShowcase')"
            :key="richMediaAdShowcase"
          >
            <sidebar-item>
              <template v-slot:avatar>
                <v-icon> mdi-domain </v-icon>
              </template>
              <template v-slot:content>
                <v-list-tile-title>
                  <span>
                    RichMediaAdShowcase
                  </span>
                </v-list-tile-title>
              </template>
            </sidebar-item>
          </v-list-tile>

          <template v-if="showFeaturesMenu">
            <v-list-tile
              class="sidebar-menu my-0"
              v-for="item in featuresMenu"
              :to="getRedirectRoute(item.routeName)"
              :key="item.path"
            >
              <sidebar-item>
                <template v-slot:avatar>
                  <!-- material icon works only inside v-icon -->
                  <v-icon>{{ item.action }}</v-icon>
                </template>
                <template v-slot:content>
                  <v-list-tile-title>
                    <component v-if="item.component" :is="item.component" />
                    <span v-else>
                      {{ $t(item.title) }}
                    </span>
                  </v-list-tile-title>
                </template>
              </sidebar-item>
            </v-list-tile>
          </template>
          <hr class="sidebar-dividers my-0" v-if="!isForCreativeBuilder">
          <template v-for="item in settingsMenu">
            <template v-if="item.items != null">
              <v-list-group
                :key="item.title"
                prepend-icon="arrow_right"
                append-icon
                no-action
                v-model="item.active"
              >
                <v-list-tile class="my-0" slot="activator">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-icon class="mr-3">
                        {{ item.action }}
                      </v-icon>
                      <span>{{ $t(item.title) }}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  class="my-0"
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  :to="getRedirectRoute"
                >
                  <template v-if="subItem !== null">
                    <sidebar-item v-if="subItem.action">
                      <template v-slot:avatar>
                        <v-icon>{{ subItem.action }}</v-icon>
                      </template>
                      <template v-slot:content>
                        <v-list-tile-title>
                          {{
                            $t(subItem.title)
                          }}
                        </v-list-tile-title>
                      </template>
                    </sidebar-item>
                  </template>
                </v-list-tile>
              </v-list-group>
            </template>
            <v-list-tile
              class="sidebar-menu my-0"
              :to="getRedirectRoute(item.routeName)"
              :key="item.routeName"
              v-else
            >
              <sidebar-item>
                <template v-slot:avatar>
                  <v-icon>{{ item.action }}</v-icon>
                </template>
                <template v-slot:content>
                  <v-list-tile-title>
                    <component v-if="item.component" :is="item.component" />
                    <span v-else>
                      {{ $t(item.title) }}
                    </span>
                  </v-list-tile-title>
                </template>
              </sidebar-item>
            </v-list-tile>
          </template>
        </vue-perfect-scrollbar>
        <v-spacer />
        <hr class="sidebar-dividers my-0">
        <user-block />
      </v-list>
    </v-toolbar>
  </div>
</template>
<style scoped>
.app-logo-container {
  display: flex;
}
.sidebar-menu > .v-list__tile--link.theme--light:hover,
.sidebar-menu > .v-list__tile--link.v-list__tile--active.theme--light {
  background: rgb(0, 0, 0, 0.2) !important;
}
.ps.ps--active-x > .ps__scrollbar-x-rail {
  display: none !important;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import BpSwitcher from 'Components/BpSwitcher/TheBpSwitcher';
// import Notifications from 'Components/Notifications/TheNotifications';
import Balance from 'Components/Balance/TheBalance';
import UserBlock from 'Components/User/TheUserBlock';
import Callback from 'Components/CallbackDialog/Callback';
import CallBackTile from 'Components/CallbackDialog/CallBackTile';
import {
  VToolbar,
  VList,
  VListGroup,
  VListTile,
  VListTileAvatar,
  VListTileTitle,
  VListTileContent,
  VSpacer,
  VIcon,
  VBtn,
  VContainer,
  VLayout,
  VFlex
} from 'vuetify/lib';
import SidebarItem from './SidebarItem';

export default {
  data() {
    return {
      settings: {
        maxScrollbarLength: 160
      }
    };
  },
  components: {
    VToolbar,
    VSpacer,
    BpSwitcher,
    Balance,
    VList,
    VListGroup,
    VListTile,
    VListTileAvatar,
    VListTileTitle,
    VListTileContent,
    VIcon,
    VBtn,
    VContainer,
    VLayout,
    VFlex,
    SidebarItem,
    UserBlock,
    Callback,
    CallBackTile
  },
  computed: {
    ...mapGetters([
      'sidebarSelectedFilter',
      'featuresMenu',
      'settingsMenu',
      'roimaticConfiguration',
      'isForCreativeBuilder',
      'businessProfileId',
      'isBrandPortal',
      'isForRichMediaAdBuilder',
      'portal',
      'isForBizgain'
    ]),
    showFeaturesMenu() {
      return (
        (this.$router.currentRoute.name !== 'storeSetup' ||
          (this.$router.currentRoute.name === 'storeSetup' &&
            !this.$route.query.isLinkNew)) &&
        this.roimaticConfiguration &&
        this.roimaticConfiguration.onboardingState >= 2
      ) || this.isForBizgain;
    }
  },
  mounted() {
    if (
      (this.$router.currentRoute.name !== 'storeSetup' ||
        (this.$router.currentRoute.name === 'storeSetup' &&
          !this.$route.query.isLinkNew)) &&
      this.roimaticConfiguration &&
      this.roimaticConfiguration.onboardingState >= 3
    ) {
      // if the user has completed or skipped audience linking , then set app menu
      this.addStatsMenuItem();
      if (!this.roimaticConfiguration.isSelfFunded) this.addWalletMenuItem();
    }
    this.setActiveMenuGroup(this.$router);
  },
  methods: {
    ...mapActions([
      'setActiveMenuGroup',
      'addStatsMenuItem',
      'addWalletMenuItem'
    ]),
    getRedirectRoute(routeName){
      return this.businessProfileId == -1 ?
        {
          name: `portal-${routeName}`
        } :
        {
          name: routeName,
          params: { businessProfileId: this.businessProfileId }
        }
    }
  }
};
</script>
<style scoped>
.sidebar {
  pointer-events: all !important;
}
</style>
